"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const heroSlider = document.querySelector(
            ".o-hero-banner__splide.splide"
        );
        if (!heroSlider) return;

        const splide = new Splide(heroSlider, {
            type: "loop",
            perPage: 1,
            autoplay: false,
            interval: 5000,
            speed: 800,
            pauseOnHover: true,
            arrows: true, // desativa geração automática
            pagination: true,
            lazyLoad: false,
            breakpoints: {
                768: {
                    arrows: false,
                    pagination: true,
                },
            },
        });

        splide.mount();
    });
}
